import { gsap } from "gsap";
import { Flip } from "gsap/Flip";
gsap.registerPlugin(Flip);

/** Set by archive year–URL sync; no-op until year sections exist */
let syncArchiveYearFromScrollPosition = () => {};

const archiveWrapper = document.querySelector(".archive__wrapper");
const archiveItems = gsap.utils.toArray(".archive__row > .archive__item");
const filterText = document.querySelector(".archive__filter-text");

if (archiveItems) {
	const filterButtons = [...document.querySelectorAll(".archive__button")];

	const filterItems = (category) => {
		const selectedCategoryItems = archiveItems.filter((item) => {
			return item.getAttribute("data-category") === category;
		});
		return selectedCategoryItems;
	};

	const filterCategory = (category, clickedButton) => {
		// Update the URL query with the selected category
		const url = new URL(window.location);
		url.searchParams.set('category', category);
		window.history.pushState({}, '', url);

		filterButtons.forEach((button) => {
			button.classList.remove("active");
		});
		clickedButton.classList.add("active");

		const state = Flip.getState(archiveItems);
		const filteredItems = filterItems(category);

		if (!filteredItems || filteredItems.length === 0) {
			archiveWrapper.style.display = "none";
			filterText.style.display = "block";
			filterText.textContent = "Fant ingenting på ditt søk";
		} else {
			archiveWrapper.style.display = "block";
			filterText.style.display = "none";
			filterText.textContent = "";
		}

		gsap.set(archiveItems, {
			display: "none",
		});

		gsap.set(filteredItems, {
			display: "inline-block",
		});

		Flip.from(state, {
			duration: 0,
			onEnter: (elements) => gsap.fromTo(elements, { opacity: 0, y: 8 }, { opacity: 1, duration: 0, y: 0, stagger: 0.03 }),
			onLeave: (elements) => gsap.to(elements, { opacity: 0, y: 8, stagger: 0, duration: 0.6 }),
		});

		queueMicrotask(() => syncArchiveYearFromScrollPosition());
		setTimeout(() => syncArchiveYearFromScrollPosition(), 120);
	};

	filterButtons.forEach((button) => {
		const category = button.getAttribute("data-category");

		button.addEventListener("click", () => {
			filterCategory(category, button);
		});
	});

	document.querySelectorAll('.archive__item a').forEach(link => {
		link.addEventListener('click', () => {
			sessionStorage.setItem('archiveScrollY', window.scrollY.toString());
		});
	});

	const urlParams = new URLSearchParams(window.location.search);
	const defaultCategory = urlParams.get('category') || "exhibition";
	const defaultButton = filterButtons.find((button) => button.getAttribute("data-category") === defaultCategory);

	if (defaultButton) {
		defaultButton.click();
	}

	const savedScrollY = sessionStorage.getItem('archiveScrollY');
	const yearParam = urlParams.get('year');

	const scrollToYearFromUrl = () => {
		const yearSection = document.querySelector(
			`.archive__wrapper [data-archive-year="${CSS.escape(yearParam)}"]`
		);
		yearSection?.scrollIntoView({ block: 'start', behavior: 'auto' });
	};

	// Explicit ?year= on the full archive page (paste / share) must win over stale session scroll.
	if (yearParam && archiveWrapper) {
		sessionStorage.removeItem('archiveScrollY');
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				scrollToYearFromUrl();
				setTimeout(scrollToYearFromUrl, 80);
				setTimeout(() => syncArchiveYearFromScrollPosition(), 250);
				setTimeout(() => syncArchiveYearFromScrollPosition(), 550);
			});
		});
	} else if (defaultButton && savedScrollY !== null) {
		sessionStorage.removeItem('archiveScrollY');
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				window.scrollTo({ top: parseInt(savedScrollY, 10), behavior: 'instant' });
			});
		});
	}
}

const yearSections = document.querySelectorAll('.archive__wrapper [data-archive-year]');
if (yearSections.length && archiveWrapper) {
	let lastSyncedYear = new URLSearchParams(window.location.search).get('year');
	let yearSyncRaf = 0;

	const syncYearToUrl = (year) => {
		if (!year || year === lastSyncedYear) {
			return;
		}
		if (getComputedStyle(archiveWrapper).display === 'none') {
			return;
		}
		const url = new URL(window.location.href);
		url.searchParams.set('year', year);
		lastSyncedYear = year;
		window.history.replaceState({}, '', url);
	};

	/**
	 * Which year block the reader has reached: the lowermost section whose top is still
	 * at or above a reference line below the viewport top (stable for short blocks; avoids
	 * a thin intersection band preferring the wrong neighbour year).
	 */
	const getActiveArchiveYear = () => {
		const ref = window.scrollY + Math.min(200, window.innerHeight * 0.2);
		let bestYear = null;
		let bestDocTop = -Infinity;
		yearSections.forEach((section) => {
			const docTop = window.scrollY + section.getBoundingClientRect().top;
			if (docTop <= ref && docTop > bestDocTop) {
				bestDocTop = docTop;
				bestYear = section.getAttribute('data-archive-year');
			}
		});
		return bestYear ?? yearSections[0]?.getAttribute('data-archive-year') ?? null;
	};

	const scheduleYearSync = () => {
		if (yearSyncRaf) {
			cancelAnimationFrame(yearSyncRaf);
		}
		yearSyncRaf = requestAnimationFrame(() => {
			yearSyncRaf = 0;
			syncYearToUrl(getActiveArchiveYear());
		});
	};

	syncArchiveYearFromScrollPosition = scheduleYearSync;

	window.addEventListener('scroll', scheduleYearSync, { passive: true });
	window.addEventListener('resize', scheduleYearSync);
	// Defer until after filter init / scroll-to-year from URL (same frame would read stale scroll).
	requestAnimationFrame(() => {
		requestAnimationFrame(() => {
			scheduleYearSync();
			setTimeout(scheduleYearSync, 200);
		});
	});
}
